import React, {useRef, useState, useEffect} from 'react';
import styles from './IntroText.module.scss'
import panelStyles from '../Panels.module.scss';

import PanelAnimations from "utils/PanelAnimations";
import {useSelector} from "react-redux";
import mainStyles from "components/homeParallax/HomeParallax.module.scss";
import {buttonClick} from "utils/Helpers";

const IntroText = (props) => {

    const windowData = useSelector(state => state.window);
    const accessible = useSelector(state => state.accessible);
    const foreGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const [animationShift, setAnimationShift] = useState()

    useEffect(()=>{
        let shift = -35;
        if(windowData.width < 800) shift = -25;
        if(windowData.width < 400) shift = -15;
        if(animationShift !== shift) setAnimationShift(shift);
    }, [windowData, animationShift])

    useEffect(()=>{
        if(props.status === 'active' && !accessible.videoActive) {
            setTimeout(()=>{
                if(foreGround.current)foreGround.current.firstChild.focus();
            }, 1000)
        }
    }, [props.status, accessible.videoActive, accessible.siteEntered])

    return !animationShift ? <></> :(
        <div ref={fixedStage} className={`${panelStyles.fixedStage}`} style={{zIndex: props.zIndex,pointerEvents: 'none'}}>
            <div className={`${panelStyles.hero}`}>
                <div ref={foreGround} className={`${panelStyles.foreGround}`}>
                    <h2 tabIndex={-1} className={styles.introText}>Inspiration can come from anywhere.<br/>Originality is where you take it.</h2>
                </div>

                <div aria-hidden={true} ref={backGround} className={`${panelStyles.backGround}`}/>

            </div>


            <span className={mainStyles.accessibleContent}  tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to next section'} onClick={props.nextPanel}/>

            <PanelAnimations fixedStage={fixedStage} backGround={backGround} foreGround={foreGround} panel={'introText'} shift={animationShift}/>

        </div>
    )
};

export default IntroText
